export default __webpack_public_path__ + "static/media/Peer_Brochure_En_211104.38c2d373.pdf";